import { makeStyles } from "@mui/styles";
import { payment_gradient_reverse } from "../../themes/colors";

const useStyles = makeStyles({
  backdrop: {
    zIndex: 10,
    color: "#fff",
  },
  card: { width: "500px" },
  card_header: {
    backgroundImage: payment_gradient_reverse,
    color: "white",
    fontWeight: "bold",
    fontSize: "15px",
    padding: "10px",
  },
  text_field: { width: "100%" },
  button_row: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    justifyContent: "flex-end",
  },
});

export default useStyles;
